function originHeaders() {
  let header = [
    {
      text: 'Học sinh',
      value: 'student',
      align: 'left',
      sortable: false,
      show: true,
      width: '30%',
    },
    {
      text: 'Ngày sinh',
      value: 'dob',
      align: 'left',
      sortable: false,
      show: true,
      width: '20%',
    },
    {
      text: 'Lớp',
      value: 'class',
      align: 'left',
      sortable: false,
      show: true,
      width: '20%',
    },
    {
      text: 'Tổng số tiền còn nợ',
      value: 'totalAmount',
      align: 'right',
      sortable: false,
      show: true,
      width: '20%',
    },
    {
      text: 'Thao tác',
      value: 'action',
      align: 'center',
      sortable: false,
      show: true,
      width: '10%',
    },
  ]
  return header
}

export const headerExcel = [
  {
    text: 'Tên học sinh',
    value: 'name',
  },
  {
    text: 'Mã số',
    value: 'code',
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
  },
  {
    text: 'Lớp',
    value: 'class',
  },
  {
    text: 'Tổng số tiền nợ',

    value: 'totalAmount',
  },
]

export { originHeaders }
